import { render } from "./Buildup.vue?vue&type=template&id=2b089422&scoped=true"
import script from "./Buildup.vue?vue&type=script&lang=js"
export * from "./Buildup.vue?vue&type=script&lang=js"

import "./Buildup.vue?vue&type=style&index=0&id=2b089422&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b089422"]])

export default __exports__